import { register, accept, reject, generateCertificate, getBy, getAcceptedCertificates, 
  getRejectedCertificates, getCertificateDocument, getAllRequest } from '@/api/NoDebtCertificate'

export default class NoDebtLetter {
  constructor() {

  }

  register = ({token_auth, rfc, name, middle_name, maternal_name, paternal_name, email, budget_keys}) => {
    return register({
      token_auth: token_auth, 
      rfc: rfc, 
      name: name, 
      middle_name: middle_name, 
      maternal_name: maternal_name, 
      paternal_name: paternal_name, 
      email: email, 
      budget_keys: budget_keys
    }).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }
  accept = (token_auth, no_debt_certificate_id) => {
    return accept(token_auth, no_debt_certificate_id).then(response => {
      return response;
    }).catch(error => {
      throw error.response.data.errors;
    });
  }

  reject = (token_auth, no_debt_certificate_id) => {
    return reject(token_auth, no_debt_certificate_id).then(response => {
      return response;
    }).catch(error => {
      throw error;
    });
  }

  generateCertificate = (token_auth, business, no_debt_certificate_id, sheets) => {
    return generateCertificate(token_auth, business, no_debt_certificate_id, sheets).then(response => {
      return response
    }).catch(error => {
      throw error;
    });
  }
  
  getBy = (token_auth) => {
    return getBy(token_auth).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  } 

  getAcceptedCertificates = (token_auth) => {
    return getAcceptedCertificates(token_auth).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  }

  getRejectedCertificates = (token_auth) => {
    return getRejectedCertificates(token_auth).then(response => {
      return response;
    }).catch(error => {
      throw error;
    })
  } 

  getCertificateDocument = (token_auth, no_debt_certificate_id) => {
    return getCertificateDocument(token_auth, no_debt_certificate_id).then(response => {
      return response
    }).catch(error => {
      throw error.response.data.response.message;
    });
  }

  getAllRequest = (token_auth) => {
    return getAllRequest(token_auth).then(response => {
      return response
    }).catch(error => {
      throw error;
    })
  }
}